module.exports = __webpack_public_path__ + "static/media/401GriffinStNW_2018-06-05_43.5e72487a.jpg";